import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { DocumentSortProperty } from 'document/model/document.sort-property';
import { DocumentType } from 'document/model/document.type';
import { SortDirection } from 'infrastructure/common/model/api.sort-direction';

import { ApiQuery } from '../../../../common/model/api.query';
import {
	documentLocalization,
	documentModule,
	documentPhase,
	documentSection,
} from '../model/document.fragments';
import { DocumentOutput } from '../model/document.output';

export interface FetchDocumentsByCriteriaParams {
	readonly name: string;
	readonly userId: string;
	readonly offset: number;
	readonly chunkSize: number;
	readonly sectionsId: string[];
	readonly types: DocumentType[];
	readonly documentsId: string[];
	readonly updateEndTimestamp: number;
	readonly updateStartTimestamp: number;
	readonly sortDirection: SortDirection;
	readonly sortProperty: DocumentSortProperty;
}

@Injectable({ providedIn: 'root' })
export class FetchDocumentsApiQuery extends ApiQuery<
	DocumentOutput[],
	FetchDocumentsByCriteriaParams
> {
	client = 'content';
	document = gql`
		query FetchDocuments(
			$name: String
			$offset: Int
			$userId: UUID
			$chunkSize: Int
			$sectionsId: [UUID]
			$types: [DocumentType]
			$documentsId: [UUID]
			$updateEndTimestamp: Long
			$updateStartTimestamp: Long
			$sortProperty: DocumentSort
			$sortDirection: Direction
		) {
			fetchDocuments(
				name: $name
				types: $types
				offset: $offset
				userId: $userId
				chunkSize: $chunkSize
				sectionsId: $sectionsId
				documentsId: $documentsId
				sortProperty: $sortProperty
				sortDirection: $sortDirection
				updateEndTimestamp: $updateEndTimestamp
				updateStartTimestamp: $updateStartTimestamp
			) {
				id
				type
				ownerId
				updateTimestamp
				phase {
					...DocumentPhase
				}
				section {
					...DocumentSection
				}
				module {
					...DocumentModule
				}
				localizations {
					...DocumentLocalization
				}
				lastOpenTimestamp
				creationTimestamp
			}
		}
		${documentPhase}
		${documentModule}
		${documentSection}
		${documentLocalization}
	`;
	method = 'fetchDocuments';
}
